<template>
  <div class="c-filter">
    <ElForm label-width="60" inline class="elementui-common-form-styles" v-highlight>
      <div>
        <ElFormItem label="抖音号" label-width="38">
          <el-select v-model="douyinNos" style="width: 180px" multiple collapse-tags filterable clearable placeholder="请选择">
            <el-option v-for="item in douyinList" :key="item.accountId" :label="item.accountName" :value="item.accountId"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="平台">
          <el-select v-model="platforms" multiple collapse-tags filterable clearable style="width: 120px" placeholder="请选择">
            <el-option v-for="item in platformsData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="游戏组">
          <el-select v-model="gameGroupIds" style="width: 180px" multiple collapse-tags filterable clearable placeholder="请选择">
            <el-option v-for="(item, index) in GAME_GROUPS" :key="index" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="游戏" label-width="38">
          <el-select v-model="gameIds" style="width: 180px" multiple collapse-tags filterable clearable placeholder="请选择">
            <el-option v-for="(item, index) in GAMES" :key="index" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <el-button type="primary" @click="sendEvent">查询</el-button>
        <el-button type="text" @click="clearAll('screen')">清空</el-button>
      </div>
      <Dimension :config="dimensions" @on-change="handleChange" />
    </ElForm>
  </div>
</template>
<script>
import { getComplexReportNativeAccounts } from '@/api/common.model.js'
import { initPageData, GAME_GROUPS, GAMES, SYS_USERS } from '@/data/global-opts'
import Dimension from '@/components/dimension/beta.vue'

// 当前页面需要的下拉数据项
const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, GAMES, SYS_USERS])

export default {
  name: 'detailFilter',
  components: {
    Dimension
  },
  computed: {
    ...PAGE_REQUIRED_OPTS
  },
  data() {
    return {
      filtersData: {},
      douyinList: [],
      platforms: [],
      platformsData: [
        { id: 1, name: '安卓' },
        { id: 2, name: 'iOS' },
        { id: 3, name: '小程序' }
      ],
      gameGroupIds: [],
      gameIds: [],
      douyinNos: [],
      title: '',
      dimensions: [
        { title: '抖音号', width: 120, fixed: true, checked: true, key: 'douyinName', d_key: 'dimDouyinNo', disabled: true },
        { title: '达人视频', width: 100, fixed: true, checked: false, key: 'darenAwemePlayUrl', d_key: 'dimDarenNo', disabled: false }
      ],
      dims: []
    }
  },
  created() {
    this.getMediaNativeAccounts()
  },
  methods: {
    buildParams() {
      const params = {
        douyinNos: this.douyinNos.length ? this.douyinNos : undefined,
        platforms: this.platforms.length ? this.platforms : undefined,
        gameGroupIds: this.gameGroupIds.length ? this.gameGroupIds : undefined,
        gameIds: this.gameIds.length ? this.gameIds : undefined
      }

      if (this.dims) {
        this.dims.forEach((dim) => (params[dim] = 1))
      }
      return params
    },
    sendEvent(type) {
      const params = this.buildParams()
      if (type === 'save') this.$emit('on-save', params)
      else {
        this.$emit('on-change', params, [])
      }
    },
    saveFilter() {
      this.sendEvent('save')
    },
    clearAll(type) {
      if (type === 'screen') {
        this.clearScreen()
      }
    },
    clearScreen() {
      this.douyinNos = []
      this.platforms = []
      this.gameGroupIds = []
      this.gameIds = []
    },
    async getMediaNativeAccounts() {
      try {
        this.douyinList = await getComplexReportNativeAccounts({ accountType: 1 })
      } catch (e) {
        console.log('eeeeee output: ', e)
      }
    },
    handleChange({ cols, dims }) {
      this.dims = dims
      this.$emit('on-change-cols', cols)
      this.sendEvent()
    }
  }
}
</script>

<style lang="scss" scoped>
.title,
.clear {
  line-height: 32px;
  font-size: 12px;
}
.el-checkbox-group {
  display: inline-block;
}
.c-filter {
  ::v-deep .el-checkbox__label {
    font-size: 12px;
  }
}

::v-deep .el-input-group__prepend {
  position: absolute;
  padding: 0;
  width: 100%;
  height: 100%;
  background: none;
  border: none;
  .prepend {
    display: flex;
    align-items: center;
    height: 100%;

    .cursor-pointer {
      > span {
        width: 100%;
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    em {
      display: inline-block;
      margin-left: 2px;
      padding: 0 5px;
      line-height: 22px;
      background: #f5f5f5;
      border: 1px solid #e9e9eb;
      border-radius: 4px;
    }
  }
}
::v-deep .el-select .el-tag__close.el-icon-close {
  right: -3px;
  top: 1px;
}
</style>
